export const environment = {
  apiBaseUrl: 'https://api.iqlabtest.com',
} as const;
